<template>
<div class="TPCN">
    <div v-if="ValueTpcn">
            <div v-for="(item,i) in imgsrc" :key="i">
           <div class="post-container margintop">                
            <div :class="useWeb == 'web'?'post-thumb-web':'post-thumb'"   v-on:click="showImage(item)" style="cursor:pointer;">
                <img style="width:100%" :src="item.img"/>
                </div>
            <div :class="useWeb == 'web'?'post-content-web' : 'post-content'">
                <h3 v-if="useWeb == 'web'" class="post-title">{{item.title}}</h3>
                <p v-else class="post-title" style="font-size:100% !important">{{item.title}}</p>
                <div class="gia">{{item.price}}</div>
                <div class="sale">{{item.sale}}</div>
                <div class="lien-he" v-on:click="ShowMessager(i)">Liên hệ </div>
            </div>
            </div>
            
            </div>
            <button v-if="!xemthemSrc2" class="btn btn-primary" v-on:click="xemthem2()">Xem Thêm >>></button>
            <div v-if="xemthemSrc2">
                <div v-for="(item,i) in imgsrc" :key="i">
                <div class="post-container margintop">                
                    <div :class="useWeb == 'web'?'post-thumb-web':'post-thumb'"   v-on:click="showImage(item)" style="cursor:pointer;">
                        <img style="width:100%" :src="item.img"/>
                        </div>
                    <div :class="useWeb == 'web'?'post-content-web' : 'post-content'">
                        <h3 v-if="useWeb == 'web'" class="post-title">{{item.title}}</h3>
                        <p v-else class="post-title" style="font-size:100% !important">{{item.title}}</p>
                        <div class="gia">{{item.price}}</div>
                        <div class="sale">{{item.sale}}</div>
                        <div class="lien-he" v-on:click="ShowMessager(i)">Liên hệ </div>
                    </div>
                    </div>
                    
                    </div>
            </div>
        </div>
      <transition v-if="showModal" name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header" >
                 <span style="font-weight: bold !important;"> {{modalTitle}} </span>
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  <img style="width:100%" :src="modalImage" />
                </slot>
              </div>
              <div class="modal-body">
                <slot name="body">
                  <span class="gia">{{modalPrice}}</span>
                  <br>
                  <span class="sale">{{modalSale}}</span>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="btn btn-danger" @click="closeImage()">
                    Đóng
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <MessagerModal 
        :showModalMessager="showModalMessager"
        @closeMessager="CloseMessager"
        @moveToPage="MoveToPage"
     />
</div>
</template>


<script>
import MessagerModal from "@/components/MessagerModal/MessagerModal.vue"
export default {
    name: 'TPCN',
    components:{
        MessagerModal,

    },
    props:{
        ValueTpcn : false,
    },
    data(){ 
        return{
            useWeb: "web",
            showModal: false,
            showModalMessager: false,
            xemthemSrc2: false,
            imgsrc: [
                    {img:"https://i.pinimg.com/originals/a8/fa/ac/a8faac2ff0e0bd49f31d7963eb3667ef.jpg",title:"DHC Rau củ quả 60 ngày",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/f3/e4/18/f3e418634aa821ef60708e6642fbdde3.jpg",title:"DHC Collagen 60 ngày",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/41/15/8f/41158fbd9c2d3263e578befc36c4cd3d.jpg",title:"DHC Vitamin tổng hợp 60 ngày",price:"Giá: 350.000 VNĐ",sale:"Sale: 280.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/bb/7c/61/bb7c618dbce58100cc9d9f82a63b4718.jpg",title:"DHC Vitamin E 60 ngày",price:"Giá: 350.000 VNĐ",sale:"Sale: 290.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/96/09/a2/9609a26fc0dc2f74cba88424332254a6.jpg",title:"DHC DHA 60 ngày",price:"",sale:""},
                    {img:"https://i.pinimg.com/originals/35/83/aa/3583aaa78e81d98f91ced4872bbf8df4.jpg",title:"sdfsdf",price:"",sale:""},
                    {img:"https://i.pinimg.com/originals/42/83/3e/42833e5496957c37f8d8d4dac7d10f81.png",title:"DHC viên uống trắng da 60 ngày",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/25/6d/db/256ddb041aca0c1c28427c8f1b7f8f89.jpg",title:"DHC vitamin C 60 ngày",price:"Giá: 350.000 VNĐ",sale:"Sale: 280.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/00/d5/7a/00d57a4e4eebf32ba52a8241acc80083.jpg",title:"Tảo vàng EX",price:"Giá:??",sale:"Sale: ??"},
                    {img:"https://i.pinimg.com/originals/87/de/80/87de80911464a52dfc79dff4bc1f42d7.jpg",title:"Tảo xoắn 2200v",price:"Giá:??",sale:"Sale: ?? VNĐ"},
                    {img:"https://i.pinimg.com/originals/b8/65/2e/b8652e493c528543603018ddcc90bfc5.jpg",title:"Tảo túi",price:"Giá: ?? VNĐ",sale:"Sale: ?? VNĐ"},
                    
                   ],
                   imgsrc2: [
                    {img:"https://i.pinimg.com/originals/a8/fa/ac/a8faac2ff0e0bd49f31d7963eb3667ef.jpg",title:"DHC Rau củ quả 60 ngày",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/f3/e4/18/f3e418634aa821ef60708e6642fbdde3.jpg",title:"DHC Collagen 60 ngày",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/41/15/8f/41158fbd9c2d3263e578befc36c4cd3d.jpg",title:"DHC Vitamin tổng hợp 60 ngày",price:"Giá: 350.000 VNĐ",sale:"Sale: 280.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/bb/7c/61/bb7c618dbce58100cc9d9f82a63b4718.jpg",title:"DHC Vitamin E 60 ngày",price:"Giá: 350.000 VNĐ",sale:"Sale: 290.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/96/09/a2/9609a26fc0dc2f74cba88424332254a6.jpg",title:"DHC DHA 60 ngày",price:"",sale:""},
                    {img:"https://i.pinimg.com/originals/35/83/aa/3583aaa78e81d98f91ced4872bbf8df4.jpg",title:"sdfsdf",price:"",sale:""},
                    {img:"https://i.pinimg.com/originals/42/83/3e/42833e5496957c37f8d8d4dac7d10f81.png",title:"DHC viên uống trắng da 60 ngày",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/25/6d/db/256ddb041aca0c1c28427c8f1b7f8f89.jpg",title:"DHC vitamin C 60 ngày",price:"Giá: 350.000 VNĐ",sale:"Sale: 280.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/00/d5/7a/00d57a4e4eebf32ba52a8241acc80083.jpg",title:"Tảo vàng EX",price:"Giá:??",sale:"Sale: ??"},
                    {img:"https://i.pinimg.com/originals/87/de/80/87de80911464a52dfc79dff4bc1f42d7.jpg",title:"Tảo xoắn 2200v",price:"Giá:??",sale:"Sale: ?? VNĐ"},
                    {img:"https://i.pinimg.com/originals/b8/65/2e/b8652e493c528543603018ddcc90bfc5.jpg",title:"Tảo túi",price:"Giá: ?? VNĐ",sale:"Sale: ?? VNĐ"},
                    
                   ],
            modalImage: null,
            modalTitle: null,
            modalPrice: null,
            modalSale:null,

        }
    },
    methods:{
        Tpcn(){
            this.ValueTpcn = !this.ValueTpcn;
        },
        showImage(img){
            this.showModal = true;
            this.modalImage = img.img;
            this.modalTitle = img.title;
            this.modalPrice = img.price;
            this.modalSale = img.sale;
        },
        closeImage(){
            this.showModal = false;
        },
        ShowMessager(){
            this.showModalMessager = true;
        },
        CloseMessager(){
            this.showModalMessager = false;
        },
        MoveToPage(){
            this.showModalMessager = false;
        },
        xemthem2(){
            this.xemthemSrc2 = true;
        }
    },
    created(){
        if(this.$device.ios || this.$device.android){
            this.useWeb = "mobile";
        }
        console.log(this.useWeb);
        
    },
}
</script>
<style scoped>
.post-container {
    margin: 20px 20px 0 0;  
    border: 2px solid rgb(248, 146, 205);
    overflow: auto
}
.margintop{
    margin-top:0px !important
}
.post-thumb {
    float: left;
    width: 100px !important;
    height: 100px !important;
}
.post-thumb-web{
     float: left;
    width: 200px !important;
    height: 200px !important;
}
.post-thumb img {
    display: block
}
.post-content {
    margin-left: 100px;
    text-align: left;
}
.post-content-web{
    margin-left: 100px;
    text-align: left;
    margin-top: 25px;
}
.post-title {
    font-weight: bold;
    font-size: 200%;
    text-align: left !important;
}
.lien-he{
    float:left;
    background-color:orange;
    padding:3px;
    border-radius:3px;
    color: red;
    margin-bottom: 2px;
    cursor: pointer;
}
.gia{
color:red;
text-decoration: line-through;
text-shadow: burlywood;
}
.sale{
color:red;
font-weight: bold;
}
/* image modal */
.modal-mask {
  position: fixed;
  z-index: 9998 !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>